import React, {Component} from 'react';
import {List, ListItem, ListItemText} from '@material-ui/core';
import {withStyles} from "@material-ui/core/styles";
import connect from "react-redux/es/connect/connect";
import {bindActionCreators} from "redux";
import ReduxCompany from "../../../../store/actionreducers/company";

class CompanyVipSidebarContent extends Component {

    state = {
        checked: [0],
    };

    handleToggle = companyId => async () => {
        /*
        * 需要處理 2 件事
        *
        * 1.選到的項目 , 底色改變
        * 2.右側 vip list 根據左側 company 改變顯示的 VIP
        *
        * */
        const {checked} = this.state;
        const currentIndex = checked.indexOf(companyId);
        const newChecked = [...checked];

        if (currentIndex === -1) {
            newChecked.push(companyId);
        } else {
            newChecked.splice(currentIndex, 1);
        }

        this.setState({
            checked: newChecked,
        });

        try {
            await this.props.getVips(companyId);
            await this.props.getCompany(companyId);
        } catch (e) {
            console.warn('you got an error = ', e);
        }
    };

    render() {
        return (
            <div>
                <List dense={true}>
                    {this.props.companies.filter((company) => {
                        return company.name.includes(this.props.sidebarSearchText);
                    }).map((company) => {
                        return (
                            <ListItem button key={company.id} onClick={this.handleToggle(company.id)}>
                                <ListItemText primary={`${company.name} ${company.groups.length}人`}/>
                            </ListItem>
                        );
                    })}
                </List>
            </div>
        );
    }
}

const styles = theme => ({
    root: {},
    button: {
        margin: theme.spacing.unit,
    },
    formControl: {
        marginBottom: 24
    },
});

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getCompanies: ReduxCompany.ActionCreator.getCompanies,
        getCompany: ReduxCompany.ActionCreator.getCompany,
        getVips: ReduxCompany.ActionCreator.getVips,
    }, dispatch);
}

function mapStateToProps({group: {groups}, company: {companies}, vip: {vips}, contactsApp}) {
    return {
        groups,
        companies,
        vips,
        sidebarSearchText: contactsApp.contacts.sidebarSearchText
    };
}

export default withStyles(styles, {withTheme: true})(connect(mapStateToProps, mapDispatchToProps)(CompanyVipSidebarContent));



// WEBPACK FOOTER //
// ./src/main/content/callHelper/companyVip/CompanyVipSidebarContent.js